<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="custom-login">
    <el-dialog
      :visible.sync="visible"
      width="380px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      custom-class="login-container"
    >
      <login-comp
        style="margin-bottom:20px;"
        class="login-dialog-container"
        :login-type="loginType"
        :wechat-status="visible"
        @goto="goTo"
      >
      </login-comp>
      <!-- 活动广告位 -->
      <section
        v-if="showAdImg && adData"
        class="login-ad-container"
      >
        <img
          class="ad-img"
          style="display:block;"
          :style="!adData.linkUrl ? '' : 'cursor: pointer;'"
          :src="$.handleAssetsUrl(adData.bannerUrl)"
          @click="linkAd(adData.linkUrl)"
        >
      </section>
    </el-dialog>
  </div>
</template>
<script>
// eslint-disable
/* eslint-disable */
import { mapMutations, mapGetters } from 'vuex'
import loginComp from '@/components/user/loginComp'
export default {
  name: 'LoginDialog',
  components: {
    loginComp
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loginType: {
      type: String,
      default: 'mobile'
    }
  },
  data() {
    let visible = this.value
    return {
      visible
    }
  },
  computed: {
    showAdImg() {
      var tmpShow = false
      if (this.adData) {
        var nowTime = new Date().getTime()
        tmpShow = this.adData.startTime * 1000 < nowTime && this.adData.endTime * 1000 > nowTime
      } else {
        tmpShow = false
      }
      return tmpShow
    }
  },
  watch: {
    value(val) {
      // console.log("登录组件接收到的value值", val, "------");
      this.visible = val
      this.isAc = this.$route.path == '/contest' ? 1 : 0
      if (val) {
        this.fetchBanner()
      }
    }
  },
  methods: {
    //跳转到页面
    goTo(str) {
      this.visible = false
      this.$emit('goto', str)
    },
    // 获取登录底部弹窗banner
    fetchBanner() {
      this.$http.get('/home/banner?type=1&category=17').then((data) => {
        if (data.data.code == 200) {
          this.adData = data.data.data && data.data.data[0]
          console.log('获取到的图片是', this.adData, '------')
        }
      })
    },
    // 底部弹窗banner链接到的页面
    linkAd(page) {
      if (!page) return
      window.open(page)
    }
  }
}
</script>
<style lang="scss">
.login-container {
  .el-dialog {
    border-radius: 5px;
    overflow: hidden;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header,
  .el-dialog__footer {
    padding-left: 0px;
  }
}
</style>
<style lang="scss" scoped>
.custom-login {
  .login-dialog-container {
    margin-bottom: 20px;
  }
  .login-ad-container {
    font-size: 0;
    width: 100%;
    height: 119px;
  }
  .ad-img {
    display: block !important;
    width: 100%;
    height: 100%;
    background-size: cover;
  }
}
</style>
